import React, { useState, useEffect, useCallback } from 'react';
import { Button, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import './ServerOffline.css';

const { Title, Text } = Typography;

const ServerOffline = ({ onRetry }) => {
  const [isRetrying, setIsRetrying] = useState(false);
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? '' : prev + '.'));
    }, 600);
    return () => clearInterval(interval);
  }, []);

  const handleRetry = useCallback(async () => {
    setIsRetrying(true);
    try {
      const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/+$/, '');
      const baseURL = API_URL.endsWith('/api') ? API_URL : `${API_URL}/api`;
      const response = await fetch(`${baseURL}/services`, { method: 'GET', signal: AbortSignal.timeout(8000) });
      if (response.ok) {
        onRetry?.();
      }
    } catch {
      // still down
    } finally {
      setIsRetrying(false);
    }
  }, [onRetry]);

  return (
    <div className="server-offline-page">
      <div className="server-offline-bg-orbs">
        <div className="orb orb-1" />
        <div className="orb orb-2" />
        <div className="orb orb-3" />
      </div>

      <div className="server-offline-card">
        <div className="server-offline-icon-wrap">
          <div className="server-offline-pulse-ring" />
          <div className="server-offline-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" opacity="0.3"/>
              <path d="M12 6v6l4 2"/>
              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" strokeWidth="2"/>
            </svg>
          </div>
        </div>

        <div className="server-offline-status">
          <span className="status-dot" />
          <Text className="status-text">Hors ligne</Text>
        </div>

        <Title level={2} className="server-offline-title">
          Serveur Indisponible
        </Title>

        <Text className="server-offline-desc">
          Notre serveur est actuellement en maintenance{dots}
          <br />
          Veuillez réessayer dans quelques instants.
        </Text>

        <div className="server-offline-actions">
          <Button
            type="primary"
            size="large"
            icon={<ReloadOutlined spin={isRetrying} />}
            onClick={handleRetry}
            loading={isRetrying}
            className="server-offline-retry-btn"
          >
            {isRetrying ? 'Vérification...' : 'Réessayer'}
          </Button>
        </div>

        <div className="server-offline-footer">
          <Text className="server-offline-code">Erreur 503 — Service Temporairement Indisponible</Text>
        </div>
      </div>
    </div>
  );
};

export default ServerOffline;
